import React from "react";
import SignatureCanvas from "react-signature-canvas";
import { Button, Form, Input } from "antd";
import throttle from "lodash/throttle";
import TextSignature from "text-signature";

import classes from "./Signature.css";

const ButtonGroup = Button.Group;

const optionsParameter = {
  width: 600,
  height: 200,
  paddingX: 100,
  paddingY: 100,
  canvasTargetDom: ".js-canvasTargetDom",
  font: ["50px", "'Nothing You Could Do'"],
  color: "black",
  textString: "",
  customFont: {
    name: "'Nothing You Could Do'",
    url:
      "https://fonts.googleapis.com/css2?family=Nothing+You+Could+Do&display=swap",
  },
};

export default class Signature extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      signImg: "",
      signText: "",
      signatureType: "drawSignature",
    };

    this.textSignature = new TextSignature({
      ...optionsParameter,
      textString: "Test",
    });
  }

  componentDidMount() {
    // if (this.props.fromDataURL) {
    //   this.sigPad.fromDataURL(this.props.fromDataURL);
    // }

    this.textSignature.generateImage({
      ...optionsParameter,
      textString: "Test",
    });
  }

  getTextSignature = () => {
    if (this.state.signText) {
      this.textSignature.generateImage({
        ...optionsParameter,
        textString: this.state.signText,
      });
      const signatureImage = this.textSignature.getImageData();
      this.setState({
        signImg: signatureImage,
      });

      this.props.form.setFieldsValue({
        [this.props.fieldName]: signatureImage,
        [`${this.props.fieldName}___date_time_delta`]: Date.now(),
      });
    } else {
      this.setState({
        signImg: undefined,
      });

      this.props.form.setFieldsValue({
        [this.props.fieldName]: undefined,
        [`${this.props.fieldName}___date_time_delta`]: undefined,
      });
    }
  };

  render() {
    const { signatureType } = this.state;

    return (
      <div className={classes.sigWrap}>
        {this.props.isPreview ? (
          <div
            style={{
              background: "#eee",
              width: "300px",
              height: "100px",
            }}
          >
            {this.props.fromDataURL && (
              <img
                src={this.props.fromDataURL}
                width={300}
                height={100}
                alt="signature"
              />
            )}
          </div>
        ) : (
          <React.Fragment>
            <div style={{ margin: "0 0 5px" }}>
              {this.props.label && (
                <div style={{ margin: "0 0 5px" }}>
                  {this.props.label} <span style={{ color: "#f00" }}>*</span>
                </div>
              )}

              <ButtonGroup>
                <Button
                  htmlType="button"
                  type={
                    signatureType === "drawSignature" ? "primary" : "secondary"
                  }
                  onClick={() => {
                    this.setState({
                      signatureType: "drawSignature",
                      signText: "",
                      signImg: "",
                    });
                    this.props.form.setFieldsValue({
                      [this.props.fieldName]: null,
                    });
                  }}
                >
                  Draw Signature
                </Button>
                <Button
                  htmlType="button"
                  type={
                    signatureType === "typeSignature" ? "primary" : "secondary"
                  }
                  onClick={() => {
                    this.setState({
                      signatureType: "typeSignature",
                      signText: "",
                      signImg: "",
                    });
                    this.props.form.setFieldsValue({
                      [this.props.fieldName]: null,
                    });
                  }}
                >
                  Type Signature
                </Button>
              </ButtonGroup>
            </div>

            {signatureType === "typeSignature" && (
              <div>
                <div>
                  <div style={{ display: "flex", margin: "0 0 10px" }}>
                    <Input
                      value={this.state.signText}
                      onChange={(e) => {
                        this.setState({ signText: e.target.value }, () => {
                          this.getTextSignature();
                        });
                      }}
                      style={{ width: "259px", margin: "0 5px 0 0" }}
                      placeholder="Signature"
                    />
                  </div>

                  {this.state.signImg && (
                    <div style={{ margin: "0 0 5px" }}>
                      <img src={this.state.signImg} width="300" height="100" />
                    </div>
                  )}

                  <Form.Item>
                    {this.props.form.getFieldDecorator(this.props.fieldName, {
                      initialValue: this.props.fromDataURL,
                      rules: [
                        {
                          required: this.props.isRequired,
                          message: "Required",
                        },
                      ],
                    })(<div />)}
                  </Form.Item>
                </div>
              </div>
            )}

            {signatureType === "drawSignature" && (
              <div className="signature-wrap">
                <div className="signature-canvas-wrap">
                  <Form.Item>
                    {this.props.form.getFieldDecorator(this.props.fieldName, {
                      initialValue: this.props.fromDataURL,
                      rules: [
                        {
                          required: this.props.isRequired,
                          message: "Required",
                        },
                      ],
                    })(
                      <SignatureCanvas
                        clearOnResize={false}
                        penColor="black"
                        canvasProps={{
                          width: 310,
                          height: 150,
                          className: "sig-canvas",
                        }}
                        ref={(ref) => {
                          this.sigPad = ref;
                        }}
                        onEnd={() => {
                          this.props.form.setFieldsValue({
                            [this.props
                              .fieldName]: this.sigPad
                              .getCanvas()
                              .toDataURL("image/png"),
                            [`${this.props.fieldName}___date_time_delta`]: Date.now(),
                          });
                        }}
                      />
                    )}
                  </Form.Item>
                </div>
                <Button
                  type="danger"
                  htmlType="button"
                  onClick={() => {
                    this.sigPad.clear();
                    this.props.form.setFieldsValue({
                      [this.props.fieldName]: null,
                    });
                  }}
                >
                  Clear
                </Button>
              </div>
            )}
          </React.Fragment>
        )}

        <div style={{ display: "none" }}>
          {this.props.form.getFieldDecorator(
            `${this.props.fieldName}___date_time_delta`
          )(<input disabled />)}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/FormBuilder/Signature/Signature.js